// @ts-strict-ignore
import * as React from 'react';
import { useRouteMatch } from 'react-router-dom';

import { useNavigate } from '@/router';
import type { RouteParam } from '@/types';

import { useGetLandingPage } from './useGetLandingPage';

const CATEGORY_ID_KEY_MAPPING = {
  apps: 'key',
  channels: 'id',
  feeds: 'board_id',
  notebooks: 'notebook_id',
};

export const useNavigateToNextItemUrl = () => {
  const match = useRouteMatch<RouteParam>('/:category/:source/:subCategory');
  const category = match?.params?.category;
  const source = match?.params?.source;
  const subCategory = match?.params?.subCategory;

  const navigate = useNavigate();
  const { landingPageRoute } = useGetLandingPage();

  return React.useCallback(
    (data: Record<string, unknown>[]) => {
      if (
        !Object.keys(CATEGORY_ID_KEY_MAPPING).includes(category) ||
        !data ||
        data.length === 0
      ) {
        navigate.replace(landingPageRoute);
      }

      const idKey =
        CATEGORY_ID_KEY_MAPPING[
          category as keyof typeof CATEGORY_ID_KEY_MAPPING
        ];
      const currentItemIndex = data.findIndex((item) => item[idKey] === source);
      const nextItemIndex = (currentItemIndex + 1) % data.length;
      const nextItemID = data[nextItemIndex][idKey];

      if (currentItemIndex === -1) {
        navigate.replace(landingPageRoute);
      }
      navigate.replace(`/${category}/${nextItemID}/${subCategory}`, null, {
        removeOldQueryParams: true,
      });
    },
    [category, navigate, source, subCategory, landingPageRoute]
  );
};
